<template>
    <v-card v-if="myData != null" flat>
        <v-card-text>
            <v-row>
                <v-col cols="2" class="d-flex align-center justify-center"><h3>{{rocnik}}. roč.</h3></v-col>
                <v-col cols="10">
                    <div class="text-right">
                        <v-btn v-for="button,index in buttons" :key="index"
                        style="width:30px;height:30px;margin:5px;cursor:pointer"
                        variant="outlined"
                        @click="setRocnik(button)"
                        >{{button}}</v-btn>
                    </div>
            </v-col>
            </v-row>
        </v-card-text>
        <v-card-text>
            <v-row v-for="skupina,index in myData.skupiny" :key="index" v-bind:id="'sk'+skupina.id">
                <v-col cols=12>
                    <v-card variant="outlined">
                        <v-card-title>
                            <v-row style="margin:2px">
                                ({{skupina.pocet - skupina.volne}}/{{skupina.pocet}})
                                &nbsp;
                                <b>{{skupina.nazov}}</b>
                                <v-spacer></v-spacer>
                                <v-icon title="Ukáž zoznam" style="margin-right:10px" @click="showList(skupina.id)">groups</v-icon>
                            </v-row>
                        </v-card-title>
                        <v-row v-if="skupina.id == rozbalitSkupinu">
                            <v-col cols=12 v-if="skupina.id == rozbalitSkupinu">
                                <v-card style="background-color:#E8F5E9" variant="outlined">
                                    <v-card-title>
                                        Zoznam prihlásených
                                        <v-icon class="btn-close" @click="rozbalitSkupinu=-1">close</v-icon>
                                    </v-card-title>
                                    <v-card-text>
                                        <ul style="margin-left:10px">
                                            <li v-for="clovek,index in ludiaVSkupine" :key="index">
                                                {{clovek.priezvisko}} {{clovek.meno}}
                                            </li>
                                        </ul>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>    
</template>

<script>
import axios from '../../axios-auth.js'


export default {
    data() {
        return {
            myData : null,
            rozbalitSkupinu: -1,
            buttons: [1,2,3,4,5],
            rocnik: 1
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)
            //this.myData = null
            this.prepareData()
        },
        prepareData() {
            axios.get('/get-study-groups-teacher/'+this.rocnik, this.$store.getters.getAxiosConfig)
            .then((res) => {
                this.myData = res.data
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        showList(_skupina_id) {
            axios.get('/get-users-in-group-teacher/'+_skupina_id, this.$store.getters.getAxiosConfig)
            .then((res) => {
                this.ludiaVSkupine = res.data.list    
                this.rozbalitSkupinu = _skupina_id            
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        setRocnik(_roc) {
            this.rocnik = _roc
            this.prepareData()
        },
        gototo(_id) {
            const myid = document.getElementById(_id);
            let position = myid.getBoundingClientRect()
            window.scrollTo(position.left, position.top + window.scrollY - 50);
        },
    }
}
</script>
